export default class FacebookAPI {
  /**
   *
   * @returns {Promise<StatusResponse>}
   */
  static login() {
    return new Promise((resolve) => {
      FB.login((response) => {
        resolve(response);
      }, { scope: 'public_profile,email' });
    });
  }

  /**
   *
   * @param route
   * @returns {Promise<unknown>}
   */
  static call(route) {
    return new Promise((resolve) => {
      FB.api(route, (response) => {
        resolve(response);
      });
    });
  }

  /**
   *
   * @returns {Promise<{id?: number, email?: string, name?: string}>}
   */
  static async me() {
    return FacebookAPI.call('/me?fields=id,name,email');
  }
}
